﻿export { Tooltips };
import VectorSource from 'ol/source/Vector.js';
import TileWMSSource from 'ol/source/TileWMS.js';
import ImageWMSSource from 'ol/source/ImageWMS.js';
import ImageSource from 'ol/source/Image.js';
import TileLayer from 'ol/layer/Tile.js';
import ImageLayer from 'ol/layer/Image.js';
import VectorLayer from 'ol/layer/Vector.js';
import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Feature from 'ol/Feature.js';
import Overlay from 'ol/Overlay.js';
import { MapStreetView } from './mapStreetView.js';
import { AvimTool } from './avimTool.js';
import { Utility } from '../Utility.js';
import { NavisionTool } from './navisionTool.js';
import { searchNetworkTool } from './searchNetworkTool.js';

/**
 * Class tooltips
 * @param {any} tooltipNodeId, tooltip node id
 * @param {any} mapNodeId, map node id
 */
const Tooltips = function (tooltipNodeId, mapNodeId) {
    // Define this
    var myTooltips = this;

    // -- begin private variable ------------------------------------------------------------------

    // Utility class
    this._utility = new Utility();

    // Tooltip node id
    this._tooltipNodeId = tooltipNodeId;

    // Map node id
    this._mapNodeId = mapNodeId;

    // Function goto entity info
    this._gotoEntityDetailCallback = null;

    // Hash that contains all information for layer tooltips
    this._hashTooltipsLayer = {};

    // Hash that contains all information for layer column tooltips
    this._hashTooltipsLayerColumn = {};

    // Hash multi feature result
    this._hashMultiFeature = {};

    // Position layer tooltips in map array layer
    this._tooltipsPosLayer = -1;

    // Feature information
    this._featureInfo = {
        id: null,
        feature: null,
        idLayer: null,
        mode: 'read',
        fromMap: false
    };

    // Style for selected layer vector
    this._tooltipsStylesSelected = [
        new Style({
            image: new CircleStyle({
                radius: 10,
                stroke: new Stroke({
                    color: 'rgba(255, 255, 0, 1)',
                    width: 2
                }),
                fill: new Fill({
                    color: 'rgba(0, 0, 255, 0.2)'
                })
            }),
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 2
            }),
            fill: new Fill({
                color: 'rgba(0, 0, 255, 0.2)'
            })
        })
    ];

    // tooltips overlay to anchor the popup to the map.
    this._overlayTooltips = null;

    // Define source layer for tooltip
    this._sourceTooltips = new VectorSource();

    // deprecated
    // Only one tooltips show
    this._showTooltips = true;

    // Layer name key
    this._layerNameKey = "";

    // Layer id key
    this._layerIdKey = "";

    // Map
    this._mapSgs = null;

    // Google street
    this._mapStreetView = null;

    // Tooltip build information
    this._tooltipBuildInfo = {
        map: null,
        pixel: null,
        tooltipCoordinate: null,
        popupElement: null
    };

    // Array of all feature found (WMS and WFS)
    this._arrayTooltipFeature = [];

    // deprecated
    // init tooltip indicator
    this._initTooltipIndicator = false;

    // deprecated
    // array with all element in the tooltip. The key of the has is the id of the feature
    this._arrayTooltipElement = [];

    // deprecated
    // Number of element in tooltip
    this._numberOfElementFind = 0;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    /**
     * Buil tooltip from click
     * @param {any} e, event
     */
    this.BuildInfoTooltips = async function (e) {
        // Initialize tooltip
        myTooltips._InitializeTooltip($('#tooltips-popup')[0], e.map, e.map.getEventPixel(e.originalEvent), e.target.getCoordinateFromPixel(e.map.getEventPixel(e.originalEvent)));

        // Get all WMS feature
        const listPromisesWms = myTooltips._GetAllFeatureFromWms(e.coordinate);

        // Get all WFS feature
        const listPromisesWfs = myTooltips._GetAllFeatureFromWfs(e);

        // execute promise all
        Promise.all(listPromisesWms.concat(listPromisesWfs)).then((results) => {

            // Set array of feature from wms and wfs source
            var addResult = false;
            results.map((result) => {
                if (result && result.length) {
                    if (!myTooltips._arrayTooltipFeature.find(c => c.featureElementId == result[0].featureElementId)) {
                        myTooltips._arrayTooltipFeature = myTooltips._arrayTooltipFeature.concat(result);
                        addResult = true;
                    }
                }
            });

            // Make tooltip if exists element in array
            if (myTooltips._arrayTooltipFeature && myTooltips._arrayTooltipFeature.length > 0 && addResult) {

                // If mobile go to the first element detail
                //if (myTooltips._utility.mobilecheck()) {
                //    myTooltips._GoToEntityDetail(0);
                //    return;
                //}

                // Build tooltip waiting
                myTooltips._ShowTooltipWaiting();

                // Sort descending array by layer position
                myTooltips._arrayTooltipFeature.sort((a, b) => b.layerPosition - a.layerPosition);

                // Fill tooltip content for all the feature;
                myTooltips._BuildTooltipContentAllFeature();
            }
        }).catch((error) => {
            console.error(error);
        });
    };

    /**
     * Buil tooltip from click
     * @param {any} e, event
     */
    this.BuildInfoTooltips_org = async function (e) {
        // Initialize tooltip
        myTooltips._InitializeTooltip($('#tooltips-popup')[0], e.map, e.map.getEventPixel(e.originalEvent), e.target.getCoordinateFromPixel(e.map.getEventPixel(e.originalEvent)));

        // Get all WMS feature
        var arrayFeatureFromWms = await myTooltips._GetAllFeatureFromWms(e.coordinate);
        if (!arrayFeatureFromWms || arrayFeatureFromWms.length == 0)
            arrayFeatureFromWms = [];

        // Get all WFS feature
        var arrayFeatureFromWfs = await myTooltips._GetAllFeatureFromWfs();
        if (!arrayFeatureFromWfs || arrayFeatureFromWfs.length == 0)
            arrayFeatureFromWfs = [];

        // Set array of feature from wms and wfs source
        myTooltips._arrayTooltipFeature = arrayFeatureFromWms.concat(arrayFeatureFromWfs);

        // Make tooltip if exists element in array
        if (myTooltips._arrayTooltipFeature && myTooltips._arrayTooltipFeature.length > 0) {

            // If mobile go to the first element detail
            //if (myTooltips._utility.mobilecheck()) {
            //    myTooltips._GoToEntityDetail(0)

            //    return;
            //}

            // Build tooltip waiting
            myTooltips._ShowTooltipWaiting();

            // Sort descending array by layer position
            myTooltips._arrayTooltipFeature.sort((a, b) => b.layerPosition - a.layerPosition);

            // Fill tooltip content for all the feature;
            myTooltips._BuildTooltipContentAllFeature();
        }
    };

    /** deprecated
     * Buil tooltip from click
     * @param {any} e, event
     */
    this.BuildInfoTooltips_deprecated = function (e) {
        // Init tooltip indicator
        myTooltips._initTooltipIndicator = true;

        // Init hash element tooltip
        myTooltips._arrayTooltipElement = [];

        // Init number of element in tooltip
        myTooltips._numberOfElementFind = 0;
        
        // Get map
        var map = e.map;

        // Get the pixel selected
        var pixel = map.getEventPixel(e.originalEvent);

        // Get coordinate
        var tooltipCoordinate = e.target.getCoordinateFromPixel(map.getEventPixel(e.originalEvent));

        // Destroy popover active
        var popupElement = $('#tooltips-popup')[0];
        $(popupElement).popover('destroy');

        // Clean tooltips source
        myTooltips._sourceTooltips.clear();

        // Reset feature info
        myTooltips._featureInfo = {
            id: null,
            feature: null,
            idLayer: null,
            mode: 'read',
            fromMap: false
        };

        // Define variable that show only one tooltips
        myTooltips._showTooltips = true;

        // Clean multi feature
        myTooltips._hashMultiFeature = {};

        // -- For each feature in the pixel -- WFS layer --
        e.map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            if (feature.getId() === undefined)
                feature.setId(-1);
            var featureLayerName = feature.getId().toString().split('.')[0];
            var featureLayerInfo = myTooltips._mapSgs.layerTree.FindLayerInfo(featureLayerName);
            var featureWorkspace = (featureLayerInfo !== null) ? featureLayerInfo.workspace : "";

            if (
                (myTooltips._IsTooltipsSelectable(layer) && layer instanceof VectorLayer && layer.getSource() instanceof VectorSource) ||
                (layer === null && myTooltips._IsTooltipsSelectableByName(featureWorkspace + ":" + feature.getId().toString().split('.')[0]))
            ) {
                // Get feature data from layer WFS
                if (myTooltips._showTooltips) {
                    // Spatial case for railway, to be remove in future
                    if (layer.get('name').indexOf('railway_point') > 0) {

                        myTooltips._mapSgs._railwayTool.OpenRailwayLocationInformation(feature);

                        return;
                    }
                    myTooltips._BuildToolTipsFromWFS(map, tooltipCoordinate, pixel, feature, layer, myTooltips._tooltipsStylesSelected);
                    //myTooltips._showTooltips = false;
                }
            }
        },
        {
            layerFilter: function (layer) {
                if (!(layer.get('name') === undefined)) {
                    return myTooltips._IsTooltipsSelectable(layer);
                }

                return false;
            },
            hitTolerance: 5
        });

        // -- For each layer in the pixel -- WMS layer --
        try {
            map.forEachLayerAtPixel(pixel, function (layer, color) {
                if (
                    myTooltips._IsTooltipsSelectable(layer) &&
                    (
                        (layer instanceof ImageLayer) || // && layer.getSource() instanceof ImageWMSSource) ||
                        (layer instanceof TileLayer) // && layer.getSource() instanceof TileWMSSource)
                    )
                ) {
                    // Get feature data from layer WMS
                    if (myTooltips._showTooltips) {
                        myTooltips._BuildToolTipsFromWMS(map, tooltipCoordinate, pixel, e, layer, myTooltips._tooltipsStylesSelected);
                        //myTooltips._showTooltips = false;
                    }
                }
            },
            null,
            function (layer) {
                if (!(layer.get('name') === undefined)) {
                    return myTooltips._IsTooltipsSelectable(layer);
                }

                return false;
            });
        }
        catch (error) {
            // do nothing
        }

        var layer = null;
        if (myTooltips._tooltipsPosLayer === -1) {
            layer = new VectorLayer(
                {
                    source: myTooltips._sourceTooltips,
                    id: 'tooltips'
                });

            map.addLayer(layer);
            myTooltips._tooltipsPosLayer = map.getLayers().getArray().length - 1;
        }
        else {
            map.getLayers().getArray()[myTooltips._tooltipsPosLayer].setSource(myTooltips._sourceTooltips);
        }
    };

    /**
     * Define callback function to go to the entity detail
     * @param {function} gotoEntityDetailCallback, goto entity callback function
     */
    this.SetGotoEntityCallback = function (gotoEntityDetailCallback) {
        myTooltips._gotoEntityDetailCallback = gotoEntityDetailCallback;
    };

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Initialize tooltip popover
     * @param {any} popupElement
     * @param {any} map
     * @param {any} pixel
     * @param {any} tooltipCoordinate
     */
    this._InitializeTooltip = function (popupElement, map, pixel, tooltipCoordinate) {

        // -- Init variable -----------------------------------------------------------------------

        // Clean tooltips source
        myTooltips._sourceTooltips.clear();

        // Reset feature info
        myTooltips._featureInfo = {
            id: null,
            feature: null,
            idLayer: null,
            mode: 'read',
            fromMap: false
        };

        // Init array of feature
        myTooltips._arrayTooltipFeature = [];

        // -- Tooltip -----------------------------------------------------------------------------

        // Tooltip build Informatiopn
        this._tooltipBuildInfo = {
            map: map,
            pixel: pixel,
            tooltipCoordinate: tooltipCoordinate,
            popupElement: popupElement
        };

        // Destroy popover active
        $(popupElement).popover('destroy');

        // -- Feature overlay ---------------------------------------------------------------------

        if (myTooltips._tooltipsPosLayer === -1) {
            var layer = new VectorLayer({
                source: myTooltips._sourceTooltips,
                id: 'tooltips',
                name: 'tooltips',
                style: myTooltips._tooltipsStylesSelected,
                zIndex: map.getLayers().getArray().length
            });

            map.addLayer(layer);
            myTooltips._tooltipsPosLayer = map.getLayers().getArray().length - 1;
        }
        //else {
        //    map.getLayers().getArray()[myTooltips._tooltipsPosLayer].setSource(myTooltips._sourceTooltips);
        //}
    }

    /**
     * Go to entity detail for a specific feature
     * @param {any} index
     */
    this._GoToEntityDetail = function (index) {
        var featureInfo = myTooltips._arrayTooltipFeature[index];

        myTooltips._featureInfo = {
            id: featureInfo.featureElementId,
            feature: featureInfo.feature,
            idLayer: featureInfo.layerInfo.id,
            mode: 'read',
            fromMap: false
        };

        myTooltips._gotoEntityDetailCallback(myTooltips._featureInfo);
        myTooltips._mapSgs._layerDetailEditName = featureInfo.layerInfo.layerName;
        myTooltips._mapSgs._layerDetailEditID = myTooltips._featureInfo.id;
    }

    /**
     * Show tooltip and highlight feature
     * @param {any} title
     * @param {any} content
     * @param {any} showWait
     * @param {}
     */
    this._ShowTooltip = function (title, content, closeWait, feature) {
        var center = myTooltips._tooltipBuildInfo.map.getView().getCenter();
        var idMapTooltips = myTooltips._mapNodeId;
        var heightMap = $('#' + idMapTooltips).height();
        var widthMap = $('#' + idMapTooltips).width();

        // Destroy popover active
        $(myTooltips._tooltipBuildInfo.popupElement).popover('destroy');

        // Create tooltip
        $(myTooltips._tooltipBuildInfo.popupElement).popover({
            'placement': 'top',
            'animation': false,
            'html': true,
            'title': title,
            'content': content
        });

        // Event on popover show
        $(myTooltips._tooltipBuildInfo.popupElement).on('inserted.bs.popover', function () {
            // Init tooltip object
            myTooltips._InitTooltipOnOpen(closeWait);
        });

        myTooltips._overlayTooltips.setPosition(myTooltips._tooltipBuildInfo.tooltipCoordinate);
        $(myTooltips._tooltipBuildInfo.popupElement).popover('show');

        // Pan popover if necessary
        myTooltips._PanMapPopover(myTooltips._tooltipBuildInfo.map, myTooltips._tooltipBuildInfo.popupElement, title, content, myTooltips._tooltipBuildInfo.pixel, center, widthMap, heightMap, closeWait);

        // Highlight feature of the tooltip
        myTooltips._sourceTooltips.clear();
        if (feature) {
            //var featureSource = new Feature({
            //    geometry: feature.getGeometry(),
            //    name: feature.getId() + "_",
            //    id: feature.getId() + "_"
            //});
            //featureSource.setId(feature.getId() + "_");
            //featureSource.setStyle(myTooltips._tooltipsStylesSelected);
            myTooltips._sourceTooltips.addFeature(feature);
        }
    }

    /**
     * Show tooltip popover waiting
     */
    this._ShowTooltipWaiting = function () {

        // -- Title --
        var title = '<div class="row" style="margin: 0px;margin-top: 6px;">';
        title += '<div class="col-md-1"></div>';
        // Title element - Layer pretty name
        title += '<div class="col-md-9" style="padding-left: 5px;padding-right: 0px;min-height: 20px;margin-top: 2px;"><span style="vertical-align: -webkit-baseline-middle;word-break: break-all;"></span></div>';
        // Title element - Close tooltip
        title += '<div class="col-md-1" style="position: relative;left: 10px;"><a id="close-popover" class="close" data-dismiss="alert">&times;</a></div>';
        title += '</div>';

        // -- Content --
        var content = myTooltips._utility.GetShowWaitHtml('tooltips-spinner', 'tooltips', true);

        // -- Show tooltip --
        myTooltips._ShowTooltip(title, content, false, null);
    }

    /**
     * Show tooltip for a feature
     * @param {int} index
     */
    this._ShowTooltipForFeature = function (index) {
        // Get feature info
        var featureInfo = myTooltips._arrayTooltipFeature[index];

        if (featureInfo.tooltipIsBuild) {
            // -- Show tooltip --
            myTooltips._ShowTooltip(featureInfo.tooltipHeader, featureInfo.tooltipContent, true, featureInfo.feature);
        }
        else {
            // -- Show tooltip wait
            myTooltips._ShowTooltipWaiting();
        }
    }

    /**
     * Get all feature from all wms layer on pixel
     * @param {any} coordinate
     */
    this._GetAllFeatureFromWms = function (coordinate) {

        const listPromises = [];
        const arrayLayerFound = [];

        myTooltips._tooltipBuildInfo.map.forEachLayerAtPixel(myTooltips._tooltipBuildInfo.pixel, function (layer) {
            if (
                myTooltips._IsTooltipsSelectable(layer) &&
                (
                    (layer instanceof ImageLayer) || // && layer.getSource() instanceof ImageWMSSource) ||
                    (layer instanceof TileLayer) // && layer.getSource() instanceof TileWMSSource)
                )
            ) {
                var viewResolution = myTooltips._tooltipBuildInfo.map.getView().getResolution();

                // Get layer information
                var layerGpId = layer.get("gpId");
                if (layerGpId == undefined) return;
                var dictLayerInfo = myTooltips._mapSgs.getSettings().treeMap.dict_layer_info[layerGpId];
                if (dictLayerInfo == undefined) return;
                var layerInfo = dictLayerInfo.layer_info;

                // Get layer name position in map
                var layerPosition = myTooltips._utility.GetLayerPositionByName(myTooltips._tooltipBuildInfo.map, layerInfo.layerNameKey);

                // Build url
                var url = "";
                switch (layerInfo.codServiceType) {
                    case "MapServer":

                        let geometryParam = `${coordinate[0]}%2C${coordinate[1]}`;
                        let geometryType = 'esriGeometryPoint';

                        const currentProj = myTooltips._tooltipBuildInfo.map.getView().getProjection().getCode().replace("EPSG:", "");

                        const createBuffer = layerInfo.geomType.toLowerCase() == 'point';

                        if (createBuffer) {

                            const resolution = myTooltips._tooltipBuildInfo.map.getView().getResolution();

                            // buffer distance in pixels
                            const bufferDistanceInPixels = 3;

                            // converts distance in pixels to map units
                            const bufferDistanceInMapUnits = bufferDistanceInPixels * resolution * ol.proj.Units.METERS_PER_UNIT[myTooltips._tooltipBuildInfo.map.getView().getProjection().getUnits()];

                            // creates a buffer polygon around the click point
                            const bufferedPolygon = ol.geom.Polygon.fromExtent([
                                coordinate[0] - bufferDistanceInMapUnits,
                                coordinate[1] - bufferDistanceInMapUnits,
                                coordinate[0] + bufferDistanceInMapUnits,
                                coordinate[1] + bufferDistanceInMapUnits
                            ]);

                            geometryParam = encodeURIComponent(JSON.stringify({ rings: [bufferedPolygon.getCoordinates()[0]], spatialReference: { wkid: currentProj } }));
                            geometryType = 'esriGeometryPolygon';
                        }

                        // incorporate layer filters
                        const whereQuery = layerInfo.hasOwnProperty('filterActive') && layerInfo.filterActive ? layerInfo.filterActive : '1%3D1';
                        // request only the fields configured for the layers tooltip
                        const outFields = dictLayerInfo.list_column.filter((column) => column.tooltip).map(column => column.column_name).join(',');

                        var paramUrl = "where=" + whereQuery + "&geometry=" + geometryParam + "&geometryType=" + geometryType +
                            "&inSR=" + currentProj + "&spatialRel=esriSpatialRelIntersects&outFields=" + outFields +
                            "&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false" +
                            "&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson";

                        url = layerInfo.serviceNameUrl + "/" + layerInfo.layerId + "/query?" + paramUrl;

                        /*var paramUrl = "where=1%3D1&geometry=" + coordinate[0] + "%2C" + coordinate[1] + "&geometryType=esriGeometryPoint" +
                            "&inSR=" + myTooltips._tooltipBuildInfo.map.getView().getProjection().getCode().replace("EPSG:", "") + "&spatialRel=esriSpatialRelIntersects&outFields=*" +
                            "&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false" +
                            "&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson";
                        url = layerInfo.serviceNameUrl + "/" + layerInfo.layerId + "/query?" + paramUrl;*/
                        break;
                    default:
                        // Geoserver url
                        url = layer.getSource().getGetFeatureInfoUrl(
                            coordinate,
                            viewResolution,
                            myTooltips._tooltipBuildInfo.map.getView().getProjection().getCode(),
                            { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
                        );
                }

                // Add layer info found
                arrayLayerFound.push({
                    layerInfo: layerInfo,
                    list_column: dictLayerInfo.list_column,
                    layerPosition: layerPosition,
                    url: url
                });
            }
        },
        null,
        {
            layerFilter: function (layer) {
                if (!(layer.get('name') === undefined)) {
                    return myTooltips._IsTooltipsSelectable(layer);
                }
                return false;
            }
        });

        // Call server for all layer found
        arrayLayerFound.forEach(async (layerFoundInfo) => {
            if (layerFoundInfo.url && layerFoundInfo.layerInfo)
                listPromises.push(fetch(layerFoundInfo.url).then(async (response) => {
                    try {

                        const parser = new GeoJSON();
                        const data = await response.json();
                        const arrayTooltipFeature = [];

                        if (data.features.length > 0) {
                            for (var i = 0; i < data.features.length; i++) {
                                // If layer name exists
                                if (myTooltips._hashTooltipsLayer[layerFoundInfo.layerInfo.layerNameKey] || myTooltips._hashTooltipsLayer[layerFoundInfo.layerInfo.id]) {
                                    var featureLayer = parser.readFeatures(data['features'][i])[0];
                                    var featureClone = featureLayer.clone();
                                    featureClone.setId(featureLayer.getId()) + "_";
                                    var featureElementId = featureLayer.getId();

                                    // Add feature information
                                    arrayTooltipFeature.push({
                                        layerInfo: layerFoundInfo.layerInfo,
                                        list_column: layerFoundInfo.list_column,
                                        layerPosition: layerFoundInfo.layerPosition,
                                        featureElementId: featureElementId,
                                        featureId: featureClone.getId(),
                                        feature: featureClone,
                                        tooltipIsBuild: false,
                                        tooltipTitle: layerFoundInfo.layerInfo.text,
                                        tooltipHeader: "",
                                        tooltipContent: "",
                                        index: -1
                                    });
                                }
                            }
                        }

                        return arrayTooltipFeature;
                    }
                    catch (error) {
                        console.error(error);
                        return [];
                    }
                }));
        });

        return listPromises;
    }

    /**
     * Get all feature from all wms layer on pixel
     * @param {any} coordinate
     */
    this._GetAllFeatureFromWms_org = function (coordinate) {
        return new Promise((resolve) => {
            var arrayTooltipFeature = [];
            var arrayLayerFound = [];

            myTooltips._tooltipBuildInfo.map.forEachLayerAtPixel(myTooltips._tooltipBuildInfo.pixel, function (layer) {
                if (
                    myTooltips._IsTooltipsSelectable(layer) &&
                    (
                        (layer instanceof ImageLayer) || // && layer.getSource() instanceof ImageWMSSource) ||
                        (layer instanceof TileLayer) // && layer.getSource() instanceof TileWMSSource)
                    )
                ) {
                    var viewResolution = myTooltips._tooltipBuildInfo.map.getView().getResolution();

                    // Get layer information
                    var layerGpId = layer.get("gpId");
                    if (layerGpId == undefined) return;
                    var dictLayerInfo = myTooltips._mapSgs.getSettings().treeMap.dict_layer_info[layerGpId];
                    if (dictLayerInfo == undefined) return;
                    var layerInfo = dictLayerInfo.layer_info;

                    // Get layer name position in map
                    var layerPosition = myTooltips._utility.GetLayerPositionByName(myTooltips._tooltipBuildInfo.map, layerInfo.layerNameKey);

                    // Build url
                    var url = "";
                    switch (layerInfo.codServiceType) {
                        case "MapServer":
                            var paramUrl = "where=1%3D1&geometry=" + coordinate[0] + "%2C" + coordinate[1] + "&geometryType=esriGeometryPoint" +
                                "&inSR=" + myTooltips._tooltipBuildInfo.map.getView().getProjection().getCode().replace("EPSG:", "") + "&spatialRel=esriSpatialRelIntersects&outFields=*" +
                                "&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false" +
                                "&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson";
                            url = layerInfo.serviceNameUrl + "/" + layerInfo.layerId + "/query?" + paramUrl;
                            break;
                        default:
                            // Geoserver url
                            url = layer.getSource().getGetFeatureInfoUrl(
                                coordinate,
                                viewResolution,
                                myTooltips._tooltipBuildInfo.map.getView().getProjection().getCode(),
                                { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
                            );
                    }

                    // Add layer info found
                    arrayLayerFound.push({
                        layerInfo: layerInfo,
                        list_column: dictLayerInfo.list_column,
                        layerPosition: layerPosition,
                        url: url
                    });
                }
            },
            null,
            function (layer) {
                if (!(layer.get('name') === undefined)) {
                    return myTooltips._IsTooltipsSelectable(layer);
                }

                return false;
            });

            // Return if not layer found
            if (arrayLayerFound.length == 0) {
                resolve([]);
            }

            // Call server for all layer found
            var layersProcessed = 0;
            arrayLayerFound.forEach(async (layerFoundInfo) =>
            {
                if (layerFoundInfo.url && layerFoundInfo.layerInfo) {
                    try {
                        var parser = new GeoJSON();
                        const response = await fetch(layerFoundInfo.url);
                        const data = await response.json();

                        if (data.features.length > 0) {
                            for (var i = 0; i < data.features.length; i++) {
                                // If layer name exists
                                if (myTooltips._hashTooltipsLayer[layerFoundInfo.layerInfo.layerNameKey] || myTooltips._hashTooltipsLayer[layerFoundInfo.layerInfo.id]) {
                                    var featureLayer = parser.readFeatures(data['features'][i])[0];
                                    var featureClone = featureLayer.clone();
                                    featureClone.setId(featureLayer.getId()) + "_";
                                    var arrayFeatureId = featureLayer.getId().split(".");
                                    var featureElementId = -1;
                                    if (arrayFeatureId.length > 1) {
                                        featureElementId = arrayFeatureId[1];
                                    }

                                    // Add feature information
                                    arrayTooltipFeature.push({
                                        layerInfo: layerFoundInfo.layerInfo,
                                        list_column: layerFoundInfo.list_column,
                                        layerPosition: layerFoundInfo.layerPosition,
                                        featureElementId: featureElementId,
                                        featureId: featureClone.getId(),
                                        feature: featureClone,
                                        tooltipIsBuild: false,
                                        tooltipTitle: layerFoundInfo.layerInfo.text,
                                        tooltipHeader: "",
                                        tooltipContent: "",
                                        index: -1
                                    });
                                }
                            }
                        }
                        layersProcessed++;

                        if (layersProcessed == arrayLayerFound.length)
                            resolve(arrayTooltipFeature);
                    }
                    catch (error) {
                        layersProcessed++;

                        if (layersProcessed == arrayLayerFound.length)
                            resolve(arrayTooltipFeature);
                    }
                }
                else {
                    layersProcessed++;

                    if (layersProcessed == arrayLayerFound.length)
                        resolve(arrayTooltipFeature);
                }
            });
        });
    }

    /**
     * Get all feature from all wfs layer on pixel
     */
    this._GetAllFeatureFromWfs = function (e) {
        return [new Promise((resolve) => {
            var arrayTooltipFeature = [];

            e.map.forEachFeatureAtPixel(myTooltips._tooltipBuildInfo.pixel, function (feature, layer) {

                // Get layer information
                if (feature.getId() === undefined)
                    feature.setId(-1);

                const featureLayerName = feature.getId().toString().split('.')[0];
                const featureLayerInfo = myTooltips._mapSgs.layerTree.FindLayerInfo(featureLayerName);
                var featureWorkspace = (featureLayerInfo !== null) ? featureLayerInfo.workspace : "";

                var featureClone = feature.clone();
                let featureElementId = -1;

                var layerGpId = layer.get("gpId");
                if (layerGpId == undefined) return;
                var dictLayerInfo = myTooltips._mapSgs.getSettings().treeMap.dict_layer_info[layerGpId];
                if (dictLayerInfo == undefined) return;
                var layerInfo = dictLayerInfo.layer_info;
                featureWorkspace = (layerInfo !== null) ? layerInfo.workspace : "";

                if (
                    (myTooltips._IsTooltipsSelectable(layer) && layer instanceof VectorLayer && layer.getSource() instanceof VectorSource) ||
                    (layer === null && myTooltips._IsTooltipsSelectableByName(featureWorkspace + ":" + layerInfo.layerName))
                ) {
                    featureClone.setId(feature.getId()) + "_";
                    const arrayFeatureId = feature.getId().split(".");

                    if (arrayFeatureId.length > 1) {
                        featureElementId = arrayFeatureId[1];
                    }

                    // Get layer name position in map
                    var layerPosition = myTooltips._utility.GetLayerPositionByName(myTooltips._tooltipBuildInfo.map, layerInfo.layerNameKey);

                    // Add feature information
                    arrayTooltipFeature.push({
                        layerInfo: layerInfo,
                        list_column: dictLayerInfo.list_column,
                        layerPosition: layerPosition,
                        featureElementId: featureElementId,
                        featureId: featureClone.getId(),
                        feature: featureClone,
                        tooltipIsBuild: false,
                        tooltipTitle: layerInfo.text,
                        tooltipHeader: "",
                        tooltipContent: "",
                        index: -1
                    });
                }
            }, {
                layerFilter: function (layer) {
                    if (!(layer.get('name') === undefined)) {
                        return myTooltips._IsTooltipsSelectable(layer);
                    }

                    return true;
                },
                hitTolerance: 5
            });

            resolve(arrayTooltipFeature);
        })];
    }

    /**
     * Get all feature from all wfs layer on pixel
     */
    this._GetAllFeatureFromWfs_org = function () {
        return new Promise((resolve) => {
            var arrayTooltipFeature = [];

            myTooltips._tooltipBuildInfo.map.forEachFeatureAtPixel(myTooltips._tooltipBuildInfo.pixel, function (feature, layer)
            {
                // Get layer information
                if (feature.getId() === undefined)
                    feature.setId(-1);
                var layerGpId = layer.get("gpId");
                if (layerGpId == undefined) return;
                var dictLayerInfo = myTooltips._mapSgs.getSettings().treeMap.dict_layer_info[layerGpId];
                if (dictLayerInfo == undefined) return;
                var layerInfo = dictLayerInfo.layer_info;
                var featureWorkspace = (layerInfo !== null) ? layerInfo.workspace : "";

                if (
                    (myTooltips._IsTooltipsSelectable(layer) && layer instanceof VectorLayer && layer.getSource() instanceof VectorSource) ||
                    (layer === null && myTooltips._IsTooltipsSelectableByName(featureWorkspace + ":" + layerInfo.layerName))
                ) {
                    var featureClone = feature.clone();
                    featureClone.setId(feature.getId()) + "_";
                    var arrayFeatureId = feature.getId().split(".");
                    var featureElementId = -1;
                    if (arrayFeatureId.length > 1) {
                        featureElementId = arrayFeatureId[1];
                    }

                    // Get layer name position in map
                    var layerPosition = myTooltips._utility.GetLayerPositionByName(myTooltips._tooltipBuildInfo.map, layerInfo.layerNameKey);

                    // Add feature information
                    arrayTooltipFeature.push({
                        layerInfo: layerInfo,
                        list_column: dictLayerInfo.list_column,
                        layerPosition: layerPosition,
                        featureElementId: featureElementId,
                        featureId: featureClone.getId(),
                        feature: featureClone,
                        tooltipIsBuild: false,
                        tooltipTitle: layerInfo.text,
                        tooltipHeader: "",
                        tooltipContent: "",
                        index: -1
                    });
                }

                resolve(arrayTooltipFeature);
            },
            {
                layerFilter: function (layer)
                {
                    if (!(layer.get('name') === undefined))
                    {
                        return myTooltips._IsTooltipsSelectable(layer);
                    }
                    return false;
                },
                hitTolerance: 5
            });

            if (arrayTooltipFeature.length == 0)
                resolve([]);
        });
    }

    /**
     * Build tooltips content for all the feature
     */
    this._BuildTooltipContentAllFeature = function () {
        var i = 0;
        myTooltips._arrayTooltipFeature.forEach((featureInfo) => {
            myTooltips._BuildTooltipContentForFeature(featureInfo, i++, myTooltips._arrayTooltipFeature.length).then((tooltipInfo) => {
                featureInfo.tooltipIsBuild = true;
                featureInfo.tooltipTitle = tooltipInfo.tooltipTitle;
                featureInfo.tooltipHeader = tooltipInfo.tooltipHeader;
                featureInfo.tooltipContent = tooltipInfo.tooltipContent;
                featureInfo.index = tooltipInfo.index;

                if (tooltipInfo.index == 0) {
                    // -- Show tooltip --
                    myTooltips._ShowTooltip(featureInfo.tooltipHeader, featureInfo.tooltipContent, true, featureInfo.feature);
                }
            });
        });
    }

    /**
     * Build tooltips content for one feature
     * @param {object} featureInfo, feature information
     * @param {int} index, index of the feature
     * @param {int} totalFeature, total feature caught
     */
    this._BuildTooltipContentForFeature = async function (featureInfo, index, totalFeature) {
        return new Promise((resolve) => {
            var tooltipInfo = {
                index: index,
                tooltipTitle: featureInfo.tooltipTitle,
                tooltipHeader: "",
                tooltipContent: ""
            };

            // -- Define tooltip header -----------------------------------------------------------

            // -- Define title name --
            switch (featureInfo.layerInfo.layerName) {
                case "vw_occurrence":
                    tooltipInfo.tooltipTitle = "Ocorrência nº" + featureInfo.featureElementId;
                    break;
                case "vw_occurrence_event":
                    if (myTooltips._mapSgs.getSettings()._mapSettings.map_info.name === 'MapOccurrence')
                        tooltipInfo.tooltipTitle = "Ocorrência nº" + featureInfo.featureElementId;
                    else
                        tooltipInfo.title = "Evento Ocorrência nº" + featureInfo.featureElementId;
                    break;
                case "vw_sinalizacao_prumo_geo":
                    if (myTooltips._mapSgs._settings.operationVisible.ManagerTrafficSignTool) {
                        tooltipInfo.tooltipTitle += `<span id="show-hide-signal" class="${myTooltips._GetShowPrumoSignsIconClass(featureInfo.featureElementId)}" style="float: right;cursor: pointer;font-size: 17px;color: #999393;" data-id-prumo="${featureInfo.featureElementId}"></span>`;
                    }
                default:
                // Do nothing
            }

            // -- Define header --

            // -- Title element - Navegation in element
            var indexShow = index + 1;
            var navigation = '<div class="row" style="margin: 0px;border-bottom: 1px solid #ebebeb;">' +
                '<div class="tooltip-previous-element-div"><a class="tooltip-previous-element" total-feature="' + totalFeature + '" index-element="' + index + '"><i class="material-icons">chevron_left</i></a></div>' +
                '<div class="tooltip-next-element-div"><a class="tooltip-next-element" total-feature="' + totalFeature + '" index-element="' + index + '"><i class="material-icons">chevron_right</i></a></div>' +
                '<div id="id-tooltip-current-element" style="text-align: center;font-weight: 100;" total-feature="' + totalFeature + '" index-element="' + index + '"><span style="position: relative;right: 18px;top: 4px;">' + indexShow + ' of ' + totalFeature + '</span></div>' +
                '</div>';

            // Title element
            var header = '<div class="row" style="margin: 0px;margin-top: 6px;">';
            // Title element - Goto element or not
            if (myTooltips._mapSgs.getSettings().getVisibleOperations().DetailLayer) {
                header += '<div class="col-md-1"><a id="tooltips-function-cable-tool-go-to-entity" class="tooltips-a-function go-to-entity2" index-element="' + index + '" id_entity="' + featureInfo.featureElementId + '"><i class="gpi gpi-info"></i></a></div>';
            }
            else {
                header += '<div class="col-md-1"></div>';
            }
            // Title element - Layer pretty name
            header += '<div class="col-md-9" style="padding-left: 5px;padding-right: 0px;min-height: 20px;margin-top: 2px;"><span style="vertical-align: -webkit-baseline-middle;word-break: break-all;">' + tooltipInfo.tooltipTitle + '</span></div>';
            // Title element - Close tooltip
            header += '<div class="col-md-1" style="position: relative;left: 10px;"><a id="close-popover" class="close" data-dismiss="alert">&times;</a></div>';
            header += '</div>';
            tooltipInfo.tooltipHeader = (totalFeature == 1) ? header : navigation + header;


            // -- Define tooltip content ----------------------------------------------------------
            var bodyHtml = "";
            var layerName = featureInfo.layerInfo.workspace + ":" + featureInfo.layerInfo.layerName;
            var arrayColumn = featureInfo.list_column;
            arrayColumn = arrayColumn.filter(columnInfo => columnInfo.tooltip == true).sort((a, b) => (a.tooltip_order > b.tooltip_order) ? 1 : -1);
            var valueHtml = "";
            for (var i = 0; i < arrayColumn.length; i++) {
                var objColumn = arrayColumn[i];
                var value = featureInfo.feature.getProperties()[objColumn.column_name];
                if (value) {
                    // Act according column type
                    switch (objColumn.column_type) {
                        case "xsd:date-time":
                            value = myTooltips._utility.TransformDateServerInDateII(value);
                            break;
                        case "xsd:date":
                            var valueDate = new Date(value);
                            value = valueDate.getFullYear() + "-" + (valueDate.getMonth() + 1).toString().padStart(2, "0") + "-" + valueDate.getDate().toString().padStart(2, "0");
                            break;
                        default:
                        // do nothing
                    }

                    // If column as ref table
                    if (objColumn.has_ref_table && value) {
                        var layerRef = myTooltips._mapSgs._settings.columnTableReferenceData.table_reference_data[objColumn.id_rel_layer_column_ref_metadata];
                        if (layerRef) {
                            var valueFind = layerRef.find(c => c.id == featureInfo.feature.getProperties()[objColumn.column_name]);
                            if (valueFind)
                                value = valueFind.value;
                        }
                    }

                    // Special column case
                    switch (objColumn.column_name) {
                        case "hiperligacao":
                            valueHtml = '<a id="id-download-file" class="' + value + '" style="color:blue;">link documentos</a>'
                            break;
                        default:
                            valueHtml = '<span style="vertical-align: -webkit-baseline-middle;">' + value + '</span>';
                    }
                }
                else
                    valueHtml = '<i style="vertical-align: -webkit-baseline-middle;">sem informa&#231;&#227;o</i>';
                // Ajust first row
                var ajustRow = 'style="inline-size: 182px;overflow: hidden;padding-left: 0px;"';
                bodyHtml += '<div class="row">' +
                    '<div class="col col-md-4 col-xs-4">' +
                    '<label class="tooltips-attribute-label" title="' + objColumn.description + '">' + objColumn.pretty_name + '</label>' +
                    '</div>' +
                    '<div class="col col-md-8 col-xs-8" ' + ajustRow + '>' + valueHtml + '</div>' +
                    '</div>';
            }

            // -- Traffic signal tooltip --
            if (myTooltips._mapSgs._settings.operationVisible.ManagerTrafficSignTool) {
                // For prumo
                if (featureInfo.layerInfo.layerName == myTooltips._mapSgs._managerTrafficSignTool.prumoInfo.layerName) {
                    bodyHtml += '<div class="tooltips-separator"></div>';
                    var arrayTrafficSign = JSON.parse(featureInfo.feature.getProperties()[myTooltips._mapSgs._managerTrafficSignTool.prumoInfo.columnJsonSinal]);
                    if (arrayTrafficSign) {
                        var i = 0;

                        const maxWidth = 82;
                        const maxHeight = 40;

                        arrayTrafficSign.forEach(trafficSignInfo => {
                            var paddingBotton = "10px";
                            if (i === arrayTrafficSign.length - 1)
                                paddingBotton = "0px";
                            i++;

                            const width = trafficSignInfo.width;
                            const height = trafficSignInfo.height;

                            const maxValue = width > height ? (width < maxWidth ? width : maxWidth) : (height < maxHeight ? height : maxHeight);

                            let nWidth = 28;
                            let nHeight = 28;

                            const aspectRatio = width / height;

                            if (aspectRatio != 1) {
                                if (width > height) {
                                    nWidth = maxValue;
                                    nHeight = maxValue / aspectRatio;
                                } else {
                                    nWidth = maxValue * aspectRatio;
                                    nHeight = maxValue;
                                }
                            }

                            bodyHtml += '<div class="row" style="padding-bottom:' + paddingBotton + '">' +
                                '<div class="col col-md-4 col-xs-4" style="text-align: center;padding-right: 0px;">' +
                                '<img class="tooltip-prumo-signal-image" src="' + trafficSignInfo.file_img_name_sinal + '" width="' + nWidth + '" height="' + nHeight + '" />' +
                                '</div>' +
                                '<div class="col col-md-8 col-xs-8" style="min-height: ' + nHeight + 'px;align-content: center;">' + trafficSignInfo.tipo_sinal + '</div>' +
                                '</div>';
                        });
                    }
                }

                // -- For support light sign --
                if (featureInfo.layerInfo.layerName == myTooltips._mapSgs._managerTrafficSignTool.supportLightSignInfo.layerName) {
                    bodyHtml += '<div class="tooltips-separator"></div>';
                    var arraySupportTrafficSign = JSON.parse(featureInfo.feature.getProperties()[myTooltips._mapSgs._managerTrafficSignTool.supportLightSignInfo.columnJsonSinal]);
                    if (arraySupportTrafficSign) {
                        var i = 0;
                        arraySupportTrafficSign.forEach(trafficLightSignInfo => {
                            var paddingBotton = "20px";
                            if (i === arraySupportTrafficSign.length - 1)
                                paddingBotton = "0px";
                            i++;
                            bodyHtml += '<div class="row" style="padding-bottom:' + paddingBotton + '">' +
                                '<div class="col col-md-4 col-xs-4" style="text-align: center;padding-right: 0px;">' +
                                '<img src="' + trafficLightSignInfo.file_img_name_sinal + '" width="28" height="28" />' +
                                '</div>' +
                                '<div class="col col-md-8 col-xs-8" style="height: 28px;align-content: center;">' + trafficLightSignInfo.tipo + '</div>' +
                                '</div>';
                        });
                    }
                }
            }

            // -- Add specific columns to tooltips --
            switch (layerName) {
                case 'GP:vw_ww_pipe_line_1':
                case 'GP_MEALHADA:vw_ww_pipe_line_1':
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>';
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // Go to profile                
                    if (layerName == 'GP:MEALHADA:vw_ww_pipe_line_1') {
                        bodyHtml += '<div class="col col-md-6"><a title="Identificação do perfil do coletor" class="tooltips-button-function tooltips-button-profile" cod-pipe-code="' + featureInfo.feature.getProperties().code + '" cod-pipe-system="' + featureInfo.feature.getProperties().id_system + '"><i class="fa fa-th"></i></a></div>';
                    } else {
                        let codePipe = featureInfo.feature.getProperties()['import_code'];
                        if (codePipe) {
                            bodyHtml += '<div class="col col-md-6"><a class="lightbox-link tooltips-button-function" rel="lightbox" target="_blank" href="PROFILES2/' + codePipe + '0001.png"><i class="fa fa-th"></i></a></div>';
                        }
                    }
                    // Go to picture
                    //bodyHtml += '<div class="col col-md-4"><a class="tooltips-button-function"><i class="fa fa-file-photo-o"></i></a></div>';
                    // View all pipe group
                    bodyHtml += '<div class="col col-md-6"><a title="Identificação do grupo do coletor" class="tooltips-button-function tooltips-button-pipe" cod-pipe-group="' + featureInfo.feature.getProperties().pipe_group + '"><i class="fa fa-share-alt"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_BCP:GP_Imoveis_Habitacao":
                case "GP_BCP:GP_Imoveis_Hoteis":
                case "GP_BCP:GP_Imoveis_morada":
                case "GP_BCP:GP_Imovel":
                case "GP_BCP:VW_ALL_IMOVEL":
                case "GP_BCP:VW_CAOPConcelho2":
                case "GP_BCP:v_SimulGeoportal2":
                case "GP_BCP:GP_Imoveis_Escritorios":
                    if (myTooltips._mapSgs.getSettings().getVisibleOperations().StreetMapView) {
                        var arrayCoord = featureInfo.feature.getGeometry().getCoordinates();

                        // Add sepatator
                        bodyHtml += '<div class="tooltips-separator" style="margin-bottom: 10px;"></div>'

                        // -- Start div for button --
                        bodyHtml += '<div class="row tooltips-button">';

                        // -- Google street btn --
                        bodyHtml += '<div class="col col-md-6"><a title="Google Street view" class="tooltips-button-function tooltips-button-google-street" longitude="' + arrayCoord[0] + '" latitude="' + arrayCoord[1] + '"><i class="material-icons">streetview</i><span>Vista de Rua</span></a></div>';

                        // -- Simulate btn --
                        $('#id-offcanvas-body-layer-detail-open-avim-tool-btn').removeClass('hidden');
                        switch (layerName) {
                            case "GP_BCP:GP_Imoveis_Hoteis":
                            case "GP_BCP:GP_Imoveis_Escritorios":
                                $('#id-offcanvas-body-layer-detail-open-avim-tool-btn').addClass('hidden');
                                break;
                            default:
                                bodyHtml += '<div class="col col-md-6"><a title="Simulação" class="tooltips-button-function tooltips-button-simulate" longitude="' + arrayCoord[0] + '" latitude="' + arrayCoord[1] + '"><i class="material-icons">business</i><span>Simulação</span></a></div>';
                                break;
                        }

                        // -- Close div button --
                        bodyHtml += '</div>';
                    }
                    break;
                case "GP_DOUROGAS:g_ramais":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // web service ramais
                    bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-tooltip" id="' + featureInfo.feature.values_.cod_ramal + '"><i class="fa fa-home"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS_PRD:g_obra":
                case "GP_DOUROGAS:g_obra":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    if (myTooltips._mapSgs._settings.operationVisible.SearchNetwork == true) {
                        // web service ramais
                        bodyHtml += '<a title="Pesquisa de obra" class="tooltips-button-function open-search-cod-obra" id="' + featureInfo.feature.values_.cod_obra + '"><i class="fa fa-home"></i></a>';
                        $('#id-worknumber-to-search').val(featureInfo.feature.values_.cod_obra)
                    }
                    // Button hiperlink
                    bodyHtml += '<a title="Abrir Hiperligação" class="tooltips-button-function" target="_blank" href="' + featureInfo.feature.values_.hiperligacao + '" style:"margin-left: 15px;"><i class="fa fa-link"></i></a>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS:g_pontos_consumo":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // web service ramais
                    bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-ponto-consumo-tooltip" id="cod_' + featureInfo.feature.values_.cod_ponto_cons + '"><i class="fa fa-home"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS:g_reservatorios":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // hiperligação
                    if (featureInfo.feature.values_.hiperligacao)
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + featureInfo.feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                    else
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS:gpr_reservatorios":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // hiperligação
                    if (featureInfo.feature.values_.hiperligacao)
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + featureInfo.feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                    else
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS_PRD:g_ramais":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // web service ramais
                    bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-tooltip" id="' + featureInfo.feature.values_.cod_ramal + '"><i class="fa fa-home"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS_PRD:g_pontos_consumo":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // web service ramais
                    bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-ponto-consumo-tooltip" id="cod_' + featureInfo.feature.values_.cod_ponto_cons + '"><i class="fa fa-home"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS_PRD:g_reservatorios":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // hiperligação
                    if (feature.values_.hiperligacao)
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + featureInfo.feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                    else
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_DOUROGAS_PRD:gpr_reservatorios":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // hiperligação
                    if (feature.values_.hiperligacao)
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + featureInfo.feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                    else
                        bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_PONTA_DELGADA:EDIFICIOS":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // Add button
                    if (myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.PatrimonyTool && myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.AlienateBuilding) {
                        bodyHtml += '<div><a title="Alienar Edifício" data-id="' + featureInfo.feature.id_.split('.')[1] + '" class="tooltips-button-function alienate-building-event" ><i class="fa fa-home"></i></a></div>';
                    }
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_PONTA_DELGADA:TERRENOS":
                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator"></div>'
                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';
                    // Add button
                    if (myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.PatrimonyTool && myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.AlienateBuilding) {
                        bodyHtml += '<div><a title="Alienar terreno" data-id="' + featureInfo.feature.id_.split('.')[1] + '" class="tooltips-button-function alienate-ground-event" ><i class="fa fa-home"></i></a></div>';
                    }
                    // -- Close div button --
                    bodyHtml += '</div>';
                    break;
                case "GP_PONTA_DELGADA:PRETENSOES":
                    if (myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.UrbanismTool) {
                        // Add sepatator
                        bodyHtml += '<div class="tooltips-separator"></div>'
                        // -- Start div for button --
                        bodyHtml += '<div class="row tooltips-button">';
                        // Add button
                        var processYear = featureInfo.feature.getProperties().ANO;
                        if (processYear.trim() === "" && featureInfo.feature.getProperties().PROCESSO.split("/")[1] !== undefined) {
                            processYear = featureInfo.feature.getProperties().PROCESSO.split("/")[1];
                            if (parseInt(processYear) >= 50) {
                                processYear = "19" + processYear;
                            }
                            else {
                                processYear = "20" + processYear;
                            }
                        }
                        var processValue = featureInfo.feature.getProperties().PROCESSO.split("/")[0] + " de " + processYear + " (" + featureInfo.feature.getProperties().TIPO + ")";
                        bodyHtml += '<div class="col col-md-10 col-xs-10" style="text-align: center;">' + processValue + '</div>';
                        bodyHtml += '<div class="col col-md-2 col-xs-2"><a title="Entidades a consultar" data-id="' + featureInfo.feature.getId() + '" processo="' + processValue + '" processYear="' + processYear  + '" class="tooltips-button-function tooltips-button-open-consult-entity" ><i class="fa fa-th"></i></a></div>';
                        // -- Close div button --
                        bodyHtml += '</div>';
                    }
                    break;
                default:
                // do nothing
            }
            tooltipInfo.tooltipContent = bodyHtml;

            resolve(tooltipInfo);
        });
    };

    /**
     * Create overlay tooltips
     * @param {any} container, container
     * @param {any} content, content
     * @param {any} closer, closer
     */
    this._CreateOverlayTooltips = function (container, content, closer) {

        // Create overlay tooltips
        myTooltips._overlayTooltips = new Overlay({
            element: container,
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });
    };

    /**
     * Fill object's whit layer with tooltips capability
     * @param {hash} hashLayerInfo, hash with all the layer
     */
    this._FillLayerTooltips = function (hashLayerInfo) {

        if (Object.keys(myTooltips._hashTooltipsLayer).length > 0) return;

        // Copy data tooltips structure
        for (var key in hashLayerInfo) {
            var layerInfoObj = hashLayerInfo[key];

            if (layerInfoObj.layer_info.has_tooltip) {
                // Fill layer info
                myTooltips._hashTooltipsLayer[layerInfoObj.layer_info.id] = layerInfoObj.layer_info;
                myTooltips._hashTooltipsLayer[layerInfoObj.layer_info.layerNameKey] = layerInfoObj.layer_info;

                // Fill column info
                myTooltips._hashTooltipsLayerColumn[layerInfoObj.layer_info.layerNameKey] = layerInfoObj.list_column;
            }
        }
    };

    /**
     * Check if layer is selected for tooltips interface
     * @param {object} layer selected
     * @returns {boolean} true if layer is tooltips avaible
     */
    this._IsTooltipsSelectable = function (layer) {

        if (layer !== null && (myTooltips._hashTooltipsLayer[layer.get('name')] || myTooltips._hashTooltipsLayer[layer.get('id')]))
            return true;

        return false;
    };

    /**
     * Check if layer is selected for tooltips interface
     * @param {string} layerName layer name selected
     * @returns {boolean} true if layer is tooltips avaible
     */
    this._IsTooltipsSelectableByName = function (layerName) {

        if (myTooltips._hashTooltipsLayer[layerName])
            return true;

        return false;
    };

    /** deprecated
     * Tooltips
     * Build tooltips from wms layer feature
     * @param {Map} map, map
     * @param {Coordinate} tooltipCoordinate, tooltips coordinates
     * @param {object} pixel, pixel from click mouse
     * @param {ol.MapBrowserEvent} evt the event.
     * @param {ol.layer} layer layer selected
     * @param {ol.source} source source of the layer
     * @param {object} styleSelect style of the selection
     */
    this._BuildToolTipsFromWMS = function (map, tooltipCoordinate, pixel, evt, layer, styleSelect) {
        var viewResolution = map.getView().getResolution();
        myTooltips._layerNameKey = layer.get("name");
        myTooltips._layerIdKey = layer.get("id");
        if (myTooltips._layerNameKey === "") return;

        // Get layer information
        var layerGpId = layer.get("gpId");
        if (layerGpId == undefined)
            return;
        var dictLayerInfo = myTooltips._mapSgs.getSettings().treeMap.dict_layer_info[layerGpId];
        if (dictLayerInfo == undefined)
            return;
        var layerInfo = dictLayerInfo.layer_info;

        var url = "";
        switch (layerInfo.codServiceType) {
            case "MapServer":
                var paramUrl = "where=1%3D1&geometry=" + evt.coordinate[0] + "%2C" + evt.coordinate[1] + "&geometryType=esriGeometryPoint" +
                    "&inSR=" + map.getView().getProjection().getCode().replace("EPSG:", "") + "&spatialRel=esriSpatialRelIntersects&outFields=*" +
                    "&returnGeometry=true&returnTrueCurves=false&returnIdsOnly=false&returnCountOnly=false&returnZ=false" +
                    "&returnM=false&returnDistinctValues=false&returnExtentOnly=false&f=geojson";
                url = layerInfo.serviceNameUrl + "/" + layerInfo.layerId + "/query?" + paramUrl;
                break;
            default:
                // Geoserver url
                url = layer.getSource().getGetFeatureInfoUrl(
                    evt.coordinate,
                    viewResolution,
                    map.getView().getProjection().getCode(),
                    { 'INFO_FORMAT': 'application/json', 'FEATURE_COUNT': 10 }
                );
        }

        if (url) {
            // Call Geoserver - Syncrone
            var parser = new GeoJSON();
            var request = $.ajax(
                {
                    method: "GET",
                    async: false,
                    url: url
                });

            // Geoserver Response
            request.done(function (data, textStatus, jqXHR) {
                if (data.features.length > 0) {
                    var hasMultiFeature = false;
                    for (var i = 0; i < data.features.length; i++) {
                        var arrayLayerNameKey = myTooltips._layerNameKey.split(":");
                        var layerNameKeySelected = "";
                        if (arrayLayerNameKey.length > 1) {
                            layerNameKeySelected = arrayLayerNameKey[1];
                        }
                        switch (layerNameKeySelected) {
                            case "vw_railway_point_bitola_class_problem_0":
                            case "vw_railway_point_bitola_class_problem_1":
                            case "vw_railway_point_bitola_class_problem_2":
                            case "vw_railway_point_bitola_class_problem_3":
                            case "vw_railway_point_align_class_problem_0":
                            case "vw_railway_point_align_class_problem_1":
                            case "vw_railway_point_align_class_problem_2":
                            case "vw_railway_point_align_class_problem_3":
                            case "vw_railway_point_long_leveling_class_problem_0":
                            case "vw_railway_point_long_leveling_class_problem_1":
                            case "vw_railway_point_long_leveling_class_problem_2":
                            case "vw_railway_point_long_leveling_class_problem_3":
                            case "railway_point":
                                var featureLayer = parser.readFeatures(data['features'][i])[0];

                                myTooltips._mapSgs._railwayTool.OpenRailwayLocationInformation(featureLayer);

                                return;
                                break;
                            case "PRETENSOES":
                                var hashObj = myTooltips._hashTooltipsLayer[myTooltips._layerNameKey] || myTooltips._hashTooltipsLayer[myTooltips._layerIdKey];
                                var layertreeName = hashObj.text;
                                var layerNameKey = hashObj.layerNameKey;
                                delete data['features'][i].properties.geometry; // no need in properties
                                var featureLayer = parser.readFeatures(data['features'][i])[0];
                                var feature = featureLayer.clone();
                                feature.setId(featureLayer.getId()) + "_";
                                feature.set('check', 1, true);
                                var featureSource = new Feature({
                                    geometry: featureLayer.getGeometry(),
                                    name: feature.getId()
                                });
                                featureSource.setId(featureLayer.getId() + "_");
                                featureSource.setStyle(styleSelect); // Associate style to feature
                                myTooltips._sourceTooltips.addFeature(featureSource);
                                myTooltips._hashMultiFeature[feature.getId()] = {
                                    layertreeName: hashObj.text,
                                    layerNameKey: hashObj.layerNameKey,
                                    tooltipCoordinate: tooltipCoordinate,
                                    pixel: pixel,
                                    feature: featureLayer
                                }
                                hasMultiFeature = true;
                                break;
                            default:
                                if (myTooltips._hashTooltipsLayer[myTooltips._layerNameKey] || myTooltips._hashTooltipsLayer[myTooltips._layerIdKey]) {
                                    var hashObj = myTooltips._hashTooltipsLayer[myTooltips._layerNameKey] || myTooltips._hashTooltipsLayer[myTooltips._layerIdKey];
                                    var layertreeName = hashObj.text;
                                    var layerNameKey = hashObj.layerNameKey;
                                    //switch (layerInfo.codServiceType) {
                                    //    case "MapServer":
                                    //        break;
                                    //    default:
                                    //        delete data['features'][i].properties.geometry; // no need in properties
                                    //}
                                    delete data['features'][i].properties.geometry; // no need in properties
                                    var featureLayer = parser.readFeatures(data['features'][i])[0];
                                    var feature = featureLayer.clone();
                                    feature.setId(featureLayer.getId()) + "_";
                                    feature.set('check', 1, true);
                                    var featureSource = new Feature({
                                        geometry: featureLayer.getGeometry(),
                                        name: feature.getId()
                                    });
                                    featureSource.setId(featureLayer.getId() + "_");
                                    featureSource.setStyle(styleSelect); // Associate style to feature
                                    myTooltips._sourceTooltips.addFeature(featureSource);

                                    // Build tooltips popup
                                    myTooltips._BuildTooltipsPopup(map, tooltipCoordinate, pixel, featureLayer, layerNameKey, layertreeName);
                                }
                        }

                        // Multi Layer
                        if (hasMultiFeature) {
                            myTooltips._BuildTooltipsPopupMulti(map, tooltipCoordinate, pixel);
                        }
                    }
                }
            });
        }
    };

    /** deprecated
     * Build tooltips from wfs layer feature
     * @param {Map} map, map
     * @param {Coordinate} tooltipCoordinate, tooltips coordinates
     * @param {object} pixel, pixel from click mouse
     * @param {ol.feature} featureLayer, feature selected
     * @param {ol.layer} layer, selected
     * @param {object} styleSelect, of the selection
     */
    this._BuildToolTipsFromWFS = function (map, tooltipCoordinate, pixel, featureLayer, layer, styleSelect) {
        var feature = featureLayer.clone();
        feature.setId(featureLayer.getId()) + "_";
        var layerNameKey = layer.get('name');
        if (layerNameKey === "") return;
        feature.set('check', 1, true);
        var hashObj = myTooltips._hashTooltipsLayer[layerNameKey] || myTooltips._hashTooltipsLayer[layer.get('id')];
        var layertreeName = hashObj.text;

        // Add feature to source
        var featureSource = new Feature({
            geometry: featureLayer.getGeometry(),
            name: feature.getId()
        });
        featureSource.setId(featureLayer.getId() + "_");
        featureSource.setStyle(styleSelect); // Associate style to feature
        myTooltips._sourceTooltips.addFeature(featureSource);

        // Build tooltips popup
        myTooltips._BuildTooltipsPopup(map, tooltipCoordinate, pixel, featureLayer, layerNameKey, layertreeName);
    };

    /** deprecated
     * Build tooltips popup
     * @param {Map} map, map
     * @param {Coordinate} tooltipCoordinate, tooltips coordinates
     * @param {object} pixel, pixel from click mouse
     */
    this._BuildTooltipsPopupMulti = function (map, tooltipCoordinate, pixel) {
        var center = map.getView().getCenter();
        var idMapTooltips = myTooltips._mapNodeId;
        var heightMap = $('#' + idMapTooltips).height();
        var widthMap = $('#' + idMapTooltips).width();
        //var bodyHtml = '<i class="glyphicon glyphicon-repeat fast-right-spinner"></i><span>&nbsp;aguardar</span>';
        var bodyHtml = myTooltips._utility.GetShowWaitHtml('tooltips-spinner', 'tooltips', true);

        var titleName = "Pretensões";
        var layerTreeNameTitle = "";
        layerTreeNameTitle += '<div class="row"><i>' + titleName + '</i></div>';
        layerTreeNameTitle += '<a id="close-popover" class="close" data-dismiss="alert">&times;</a>';

        // Build popover
        var popupElement = $('#' + myTooltips._tooltipNodeId)[0];
        $(popupElement).popover('destroy');

        $(popupElement).popover({
            'placement': 'top',
            'animation': false,
            'html': true,
            'title': layerTreeNameTitle,
            'content': bodyHtml
        });

        // Event on popover show
        $(popupElement).on('inserted.bs.popover', function () {
            // Init tooltip object
            myTooltips._InitTooltipOnOpen();

            // Event to high light pipe group
            $('.tooltips-button-open-consult-entity').off('click').on('click', function () {
                var key = $(this).attr("key");
                var processo = $(this).attr("processo");
                var ObjProcess = myTooltips._hashMultiFeature[key].feature.getProperties();
                $('#id-modal-pdm-analyze-entity-result-process')[0].innerHTML = processo;

                // Close tooltip
                myTooltips._CloseTooltip();

                // Clean Entity
                $('#id-modal-pdm-analyze-entity-result-layer ul').empty();

                // Fill process info
                var processYear = feature.getProperties().ANO;
                var processNumber = feature.getProperties().PROCESSO.split("/")[0];
                if (processYear.trim() === "" && feature.getProperties().PROCESSO.split("/")[1] !== undefined) {
                    processYear = feature.getProperties().PROCESSO.split("/")[1];
                    if (parseInt(processYear) >= 50) {
                        processYear = "19" + processYear;
                    }
                    else {
                        processYear = "20" + processYear;
                    }
                }

                $('#id-modal-pdm-analyze-entity-result-process span.id-process')[0].innerHTML = ObjProcess.PROCESSO.split("/")[0];
                $('#id-modal-pdm-analyze-entity-result-process span.type')[0].innerHTML = ObjProcess.TIPO;
                $('#id-modal-pdm-analyze-entity-result-process span.date')[0].innerHTML = myTooltips._utility.TransformDateServerInDateII(ObjProcess.DATA);
                $('#id-modal-pdm-analyze-entity-result-process span.year')[0].innerHTML = processYear;
                $('#id-modal-pdm-analyze-entity-result-process span.area')[0].innerHTML = ObjProcess.AREA + " m" + "<sup>2</sup>";

                app.sgs.Map._territorialManagement.ExecutePdmAnalyzeEntity(myTooltips._hashMultiFeature[key].feature);
            });
        })

        popupElement.setAttribute('title', layerTreeNameTitle);
        popupElement.setAttribute('data-original-title', layerTreeNameTitle);
        $(popupElement).attr('data-content', '').data('bs.popover').setContent();
        myTooltips._overlayTooltips.setPosition(tooltipCoordinate);
        $(popupElement).popover('show');

        // Pan popover if necessary
        myTooltips._PanMapPopover(map, popupElement, layerTreeNameTitle, bodyHtml, pixel, center, widthMap, heightMap);

        var arrayKeyMultiFeature = Object.keys(myTooltips._hashMultiFeature);
        for (var i = 0; i < arrayKeyMultiFeature.length; i++) {
            var key = arrayKeyMultiFeature[i];
            var objFeature = myTooltips._hashMultiFeature[key];
            var feature = objFeature.feature;
            var processYear = feature.getProperties().ANO;
            var processNumber = feature.getProperties().PROCESSO.split("/")[0];
            if (processYear.trim() === "" && feature.getProperties().PROCESSO.split("/")[1] !== undefined) {
                processYear = feature.getProperties().PROCESSO.split("/")[1];
                if (parseInt(processYear) >= 50) {
                    processYear = "19" + processYear;
                }
                else {
                    processYear = "20" + processYear;
                }
            }
            var processValue = feature.getProperties().PROCESSO.split("/")[0] + " de " + processYear + " (" + feature.getProperties().TIPO + ")";
            bodyHtml += '<div class="row">' +
                '<div class="col col-md-2 col-xs-2">' +
                '<label class="tooltips-attribute-label" title="Processo">processo</label>' +
                '</div>' +
                '<div class="col col-md-8 col-xs-8" style="text-align: center;">' + processValue + '</div>' +
                '<div class="col col-md-2 col-xs-2" style="position: relative;bottom: 7px;"><a title="Entidades a consultar" key="' + key + '" processo="' + processValue + '" class="tooltips-button-function tooltips-button-open-consult-entity"><i class="fa fa-th"></i></a></div>' +
                '</div>';
        }

        popupElement.setAttribute('title', layerTreeNameTitle);
        $(popupElement).attr('data-content', bodyHtml).data('bs.popover').setContent();
        $(popupElement).popover('show');

        // Pan popover if necessary
        myTooltips._PanMapPopover(map, popupElement, layerTreeNameTitle, bodyHtml, pixel, center, widthMap, heightMap);
    }

    /** deprecated
     * Build tooltips popup
     * @param {Map} map, map
     * @param {Coordinate} tooltipCoordinate, tooltips coordinates
     * @param {object} pixel, pixel from click mouse
     * @param {ol.Feature} feature, feature
     * @param {string} layerNameKey, layer name key
     * @param {string} layertreeName, layertree name
     */
    this._BuildTooltipsPopup = function (map, tooltipCoordinate, pixel, feature, layerNameKey, layertreeName) {
        window["temp_feature"] = feature;
        var center = map.getView().getCenter();
        var idMapTooltips = myTooltips._mapNodeId;
        var heightMap = $('#' + idMapTooltips).height();
        var widthMap = $('#' + idMapTooltips).width();
        var bodyHtml = myTooltips._utility.GetShowWaitHtml('tooltips-spinner', 'tooltips', true);

        // Set number of element
        myTooltips._numberOfElementFind++;

        // Set feature info
        if (feature.getId() == undefined)
            myTooltips._featureInfo.id = -1;
        else
            myTooltips._featureInfo.id = feature.getId().toString().split('.')[1];
        myTooltips._featureInfo.feature = feature;
        myTooltips._featureInfo.idLayer = myTooltips._hashTooltipsLayer[layerNameKey].id;;

        // Define title
        var layerNameInput = layerNameKey.split(":")[1];
        var titleName = layertreeName;
        switch (layerNameInput) {
            case "vw_occurrence":
                titleName = "Ocorrência nº" + feature.id_.split('.')[1];
                break;
            case "vw_occurrence_event":
                if (myTooltips._mapSgs.getSettings()._mapSettings.map_info.name === 'MapOccurrence')
                    titleName = "Ocorrência nº" + feature.id_.split('.')[1];
                else
                    titleName = "Evento Ocorrência nº" + feature.id_.split('.')[1];
                break;
            case "vw_sinalizacao_prumo_geo":
                if (myTooltips._mapSgs._settings.operationVisible.ManagerTrafficSignTool) {
                    titleName += `<span id="show-hide-signal" class="${myTooltips._GetShowPrumoSignsIconClass(feature.get('id'))}" style="float: right;cursor: pointer;font-size: 17px;color: #999393;" data-id-prumo="${feature.get('id')}"></span>`;
                }
            default:
            // Do nothing
        }

        if (myTooltips._utility.mobilecheck()) {

            myTooltips._gotoEntityDetailCallback(myTooltips._featureInfo);

            myTooltips._mapSgs._layerDetailEditName = myTooltips._featureInfo.feature.id_.split('.')[0];

            myTooltips._mapSgs._layerDetailEditID = myTooltips._featureInfo.id;

            return;
        }

        // Title element
        var titleTooltipElement = '';
        // Title element - Navegation in element
        var indexElement = myTooltips._numberOfElementFind - 1;
        var tooltipElementNavigation = '<div class="row" style="margin: 0px;border-bottom: 1px solid #ebebeb;">' +
            '<div class="tooltip-previous-element-div"><a class="tooltip-previous-element" index-element="' + indexElement + '"><i class="material-icons">chevron_left</i></a></div>' +
            '<div class="tooltip-next-element-div"><a class="tooltip-next-element" index-element="' + indexElement + '"><i class="material-icons">chevron_right</i></a></div>' +
            '<div id="id-tooltip-current-element" style="text-align: center;font-weight: 100;" index-element="' + indexElement + '"><span style="position: relative;right: 18px;top: 4px;">' + myTooltips._numberOfElementFind + ' of [TOTAL_ELEMENT]</span></div>' +
            '</div>';

        // Title element
        var layerTreeNameTitle = '<div class="row" style="margin: 0px;margin-top: 6px;">';
        // Title element - Goto element or not
        if (myTooltips._mapSgs.getSettings().getVisibleOperations().DetailLayer) {
            layerTreeNameTitle += '<div class="col-md-1"><a id="tooltips-function-cable-tool-go-to-entity" class="tooltips-a-function go-to-entity2" id_entity="' + myTooltips._featureInfo.id + '"><i class="gpi gpi-info"></i></a></div>';
        }
        else {
            layerTreeNameTitle += '<div class="col-md-1"></div>';
        }
        // Title element - Layer pretty name
        layerTreeNameTitle += '<div class="col-md-9" style="padding-left: 5px;padding-right: 0px;min-height: 20px;margin-top: 2px;"><span style="vertical-align: -webkit-baseline-middle;word-break: break-all;">' + titleName + '</span></div>';
        // Title element - Close tooltip
        layerTreeNameTitle += '<div class="col-md-1" style="position: relative;left: 10px;"><a id="close-popover" class="close" data-dismiss="alert">&times;</a></div>';
        layerTreeNameTitle += '</div>';
        titleTooltipElement = (myTooltips._numberOfElementFind > 1) ? tooltipElementNavigation.replace("[TOTAL_ELEMENT]", myTooltips._numberOfElementFind) + layerTreeNameTitle : layerTreeNameTitle;

        // Build popover
        var popupElement = $('#' + myTooltips._tooltipNodeId)[0];

        if (myTooltips._initTooltipIndicator) {
            $(popupElement).popover('destroy');

            $(popupElement).popover({
                'placement': 'top',
                'animation': false,
                'html': true,
                'title': titleTooltipElement,
                'content': bodyHtml
            });
        }
        else {
            myTooltips._initTooltipIndicator = false;
        }

        // Event on popover show
        $(popupElement).on('inserted.bs.popover', function () {
            // Init tooltip object
            myTooltips._InitTooltipOnOpen();
        });

        popupElement.setAttribute('title', titleTooltipElement);
        popupElement.setAttribute('data-original-title', titleTooltipElement);
        $(popupElement).attr('data-content', '').data('bs.popover').setContent();
        myTooltips._overlayTooltips.setPosition(tooltipCoordinate);
        $(popupElement).popover('show');

        // Pan popover if necessary
        myTooltips._PanMapPopover(map, popupElement, titleTooltipElement, bodyHtml, pixel, center, widthMap, heightMap);

        // Build tooltip content
        let layerName = layerNameKey.split(':').length >= 2 ? layerNameKey.split(':')[0] + ':' + layerNameKey.split(':')[1] : undefined;
        var arrayColumn = myTooltips._hashTooltipsLayerColumn[layerNameKey];
        arrayColumn = arrayColumn.sort((a, b) => (a.tooltip_order > b.tooltip_order) ? 1 : -1);
        bodyHtml = myTooltips._utility.GetShowWaitHtml('tooltips-spinner', 'tooltips', true) + '<div>';
        var valueHtml = "";
        /*var firstRow = true;*/
        for (var i = 0; i < arrayColumn.length; i++) {
            var objColumn = arrayColumn[i];
            var value = feature.getProperties()[objColumn.column_name];
            if (objColumn.tooltip) {
                if (value) {
                    // Act according column type
                    switch (objColumn.column_type) {
                        case "xsd:date-time":
                            value = myTooltips._utility.TransformDateServerInDateII(value);
                            break;
                        case "xsd:date":
                            var valueDate = new Date(value);
                            value = valueDate.getFullYear() + "-" + (valueDate.getMonth() + 1).toString().padStart(2, "0") + "-" + valueDate.getDate().toString().padStart(2, "0");
                            break;
                        default:
                        // do nothing
                    }

                    // If column as ref table
                    if (objColumn.has_ref_table && value) {
                        var layerRef = myTooltips._mapSgs._settings.columnTableReferenceData.table_reference_data[objColumn.id_rel_layer_column_ref_metadata];
                        if (layerRef) {
                            var valueFind = layerRef.find(c => c.id == feature.getProperties()[objColumn.column_name]);
                            if (valueFind)
                                value = valueFind.value;
                        }
                    }

                    // Special column case
                    switch (objColumn.column_name) {
                        case "hiperligacao":
                            valueHtml = '<a id="id-download-file" class="' + value + '" style="color:blue;">link documentos</a>'
                            break;
                        default:
                            valueHtml = '<span style="vertical-align: -webkit-baseline-middle;">' + value + '</span>';
                    }
                }
                else
                    valueHtml = '<i style="vertical-align: -webkit-baseline-middle;">sem informa&#231;&#227;o</i>';
                // Ajust first row
                var ajustRow = 'style="inline-size: 182px;overflow: hidden;padding-left: 0px;"';
                //if (firstRow) {
                //    ajustRow = 'style="bottom: 6px;inline-size: 182px;overflow: hidden;padding-left: 0px;"';
                //    firstRow = false;
                //}
                bodyHtml += '<div class="row">' +
                    '<div class="col col-md-4 col-xs-4">' +
                    '<label class="tooltips-attribute-label" title="' + objColumn.description + '">' + objColumn.pretty_name + '</label>' +
                    '</div>' +
                    '<div class="col col-md-8 col-xs-8" ' + ajustRow + '>' + valueHtml + '</div>' +
                    '</div>';
            }
        }

        // Traffic signal tooltip
        if (myTooltips._mapSgs._settings.operationVisible.ManagerTrafficSignTool) {
            // For prumo
            if (layerName.indexOf(myTooltips._mapSgs._managerTrafficSignTool.prumoInfo.layerName) > 0) {
                bodyHtml += '<div class="tooltips-separator"></div>';
                var arrayTrafficSign = JSON.parse(feature.getProperties()[myTooltips._mapSgs._managerTrafficSignTool.prumoInfo.columnJsonSinal]);
                if (arrayTrafficSign) {
                    var i = 0;

                    const maxWidth = 82;
                    const maxHeight = 40;

                    arrayTrafficSign.forEach(trafficSignInfo => {
                        var paddingBotton = "10px";
                        if (i === arrayTrafficSign.length - 1)
                            paddingBotton = "0px";
                        i++;

                        const width = trafficSignInfo.width;
                        const height = trafficSignInfo.height;

                        const maxValue = width > height ? (width < maxWidth ? width : maxWidth) : (height < maxHeight ? height : maxHeight);

                        let nWidth = 28;
                        let nHeight = 28;

                        //if (width != maxValue && height != maxValue) {

                            const aspectRatio = width / height;

                            if (aspectRatio != 1) {
                                if (width > height) {
                                    nWidth = maxValue;
                                    nHeight = maxValue / aspectRatio;
                                } else {
                                    nWidth = maxValue * aspectRatio;
                                    nHeight = maxValue;
                                }
                            }
                        //}

                        bodyHtml += '<div class="row" style="padding-bottom:' + paddingBotton + '">' +
                            '<div class="col col-md-4 col-xs-4" style="text-align: center;padding-right: 0px;">' +
                            '<img class="tooltip-prumo-signal-image" src="' + trafficSignInfo.file_img_name_sinal + '" width="' + nWidth + '" height="' + nHeight + '" />' +
                            '</div>' +
                            '<div class="col col-md-8 col-xs-8" style="min-height: ' + nHeight +'px;align-content: center;">' + trafficSignInfo.tipo_sinal + '</div>' +
                            '</div>';
                    });
                }
            }

            // For support light sign
            if (layerName.indexOf(myTooltips._mapSgs._managerTrafficSignTool.supportLightSignInfo.layerName) > 0) {
                bodyHtml += '<div class="tooltips-separator"></div>';
                var arraySupportTrafficSign = JSON.parse(feature.getProperties()[myTooltips._mapSgs._managerTrafficSignTool.supportLightSignInfo.columnJsonSinal]);
                if (arraySupportTrafficSign) {
                    var i = 0;
                    arraySupportTrafficSign.forEach(trafficLightSignInfo => {
                        var paddingBotton = "20px";
                        if (i === arraySupportTrafficSign.length - 1)
                            paddingBotton = "0px";
                        i++;
                        bodyHtml += '<div class="row" style="padding-bottom:' + paddingBotton + '">' +
                            '<div class="col col-md-4 col-xs-4" style="text-align: center;padding-right: 0px;">' +
                            '<img src="' + trafficLightSignInfo.file_img_name_sinal + '" width="28" height="28" />' +
                            '</div>' +
                            '<div class="col col-md-8 col-xs-8" style="height: 28px;align-content: center;">' + trafficLightSignInfo.tipo + '</div>' +
                            '</div>';
                    });
                }
            }
        }

        // Add specific columns to tooltips 
        switch (layerName) {
            case 'GP:vw_ww_pipe_line_1':
            case 'GP_MEALHADA:vw_ww_pipe_line_1':
                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>';
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // Go to profile                
                if (layerName = 'GP:MEALHADA:vw_ww_pipe_line_1') {
                    bodyHtml += '<div class="col col-md-6"><a title="Identificação do perfil do coletor" class="tooltips-button-function tooltips-button-profile" cod-pipe-code="' + feature.getProperties().code + '" cod-pipe-system="' + feature.getProperties().id_system + '"><i class="fa fa-th"></i></a></div>';
                } else {
                    let codePipe = feature.getProperties()['import_code'];
                    if (codePipe) {
                        bodyHtml += '<div class="col col-md-6"><a class="lightbox-link tooltips-button-function" rel="lightbox" target="_blank" href="PROFILES2/' + codePipe + '0001.png"><i class="fa fa-th"></i></a></div>';
                    }
                }
                // Go to picture
                //bodyHtml += '<div class="col col-md-4"><a class="tooltips-button-function"><i class="fa fa-file-photo-o"></i></a></div>';
                // View all pipe group
                bodyHtml += '<div class="col col-md-6"><a title="Identificação do grupo do coletor" class="tooltips-button-function tooltips-button-pipe" cod-pipe-group="' + feature.getProperties().pipe_group + '"><i class="fa fa-share-alt"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            //case "GP_PONTA_DELGADA:PRETENSOES":
            //    bodyHtml += '<div class="col col-md-12" style="border-top: 1px solid #ebebeb;"><a title="Entidades a consultar" class="tooltips-button-function tooltips-button-consult-entity" style="position: relative;float: right;padding-top: 5px;padding-bottom: 5px;"><i class="fa fa-th"></i></a></div>';
            //    break;
            case "GP_BCP:GP_Imoveis_Habitacao":
            case "GP_BCP:GP_Imoveis_Hoteis":
            case "GP_BCP:GP_Imoveis_morada":
            case "GP_BCP:GP_Imovel":
            case "GP_BCP:VW_ALL_IMOVEL":
            case "GP_BCP:VW_CAOPConcelho2":
            case "GP_BCP:v_SimulGeoportal2":
            case "GP_BCP:GP_Imoveis_Escritorios":
                if (myTooltips._mapSgs.getSettings().getVisibleOperations().StreetMapView) {
                    var arrayCoord = feature.getGeometry().getCoordinates();

                    // Add sepatator
                    bodyHtml += '<div class="tooltips-separator" style="margin-bottom: 10px;"></div>'

                    // -- Start div for button --
                    bodyHtml += '<div class="row tooltips-button">';

                    // -- Google street btn --
                    bodyHtml += '<div class="col col-md-6"><a title="Google Street view" class="tooltips-button-function tooltips-button-google-street" longitude="' + arrayCoord[0] + '" latitude="' + arrayCoord[1] + '"><i class="material-icons">streetview</i><span>Vista de Rua</span></a></div>';

                    // -- Simulate btn --
                    $('#id-offcanvas-body-layer-detail-open-avim-tool-btn').removeClass('hidden');
                    switch (layerName) {
                        case "GP_BCP:GP_Imoveis_Hoteis":
                        case "GP_BCP:GP_Imoveis_Escritorios":
                            $('#id-offcanvas-body-layer-detail-open-avim-tool-btn').addClass('hidden');
                            break;
                        default:
                            bodyHtml += '<div class="col col-md-6"><a title="Simulação" class="tooltips-button-function tooltips-button-simulate" longitude="' + arrayCoord[0] + '" latitude="' + arrayCoord[1] + '"><i class="material-icons">business</i><span>Simulação</span></a></div>';
                            break;
                    }

                    // -- Close div button --
                    bodyHtml += '</div>';
                }
                break;
            case "GP_DOUROGAS:g_ramais":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // web service ramais
                bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-tooltip" id="' + feature.values_.cod_ramal + '"><i class="fa fa-home"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS_PRD:g_obra":
            case "GP_DOUROGAS:g_obra":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                if (myTooltips._mapSgs._settings.operationVisible.SearchNetwork == true) {
                    // web service ramais
                    bodyHtml += '<a title="Pesquisa de obra" class="tooltips-button-function open-search-cod-obra" id="' + feature.values_.cod_obra + '"><i class="fa fa-home"></i></a>';
                    $('#id-worknumber-to-search').val(feature.values_.cod_obra)
                }
                // Button hiperlink
                bodyHtml += '<a title="Abrir Hiperligação" class="tooltips-button-function" target="_blank" href="' + feature.values_.hiperligacao + '" style:"margin-left: 15px;"><i class="fa fa-link"></i></a>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS:g_pontos_consumo":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // web service ramais
                bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-ponto-consumo-tooltip" id="cod_' + feature.values_.cod_ponto_cons + '"><i class="fa fa-home"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS:g_reservatorios":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // hiperligação
                if (feature.values_.hiperligacao)
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                else
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS:gpr_reservatorios":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // hiperligação
                if (feature.values_.hiperligacao)
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                else
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;

            case "GP_DOUROGAS_PRD:g_ramais":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // web service ramais
                bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-tooltip" id="' + feature.values_.cod_ramal + '"><i class="fa fa-home"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
                //case "GP_DOUROGAS_PRD:g_obra":

                //    if (myTooltips._mapSgs._settings.operationVisible.SearchNetwork == true) {

                //        // Add sepatator
                //        bodyHtml += '<div class="tooltips-separator"></div>'
                //        // -- Start div for button --
                //        bodyHtml += '<div class="row tooltips-button">';
                //        // web service ramais
                //        bodyHtml += '<div><a title="Pesquisa de obra" class="tooltips-button-function open-search-cod-obra" id="' + feature.values_.cod_obra + '"><i class="fa fa-home"></i></a></div>';
                //        // -- Close div button --
                //        bodyHtml += '</div>';

                //        $('#id-worknumber-to-search').val(feature.values_.cod_obra)

                //    }
                break;
            case "GP_DOUROGAS_PRD:g_pontos_consumo":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // web service ramais
                bodyHtml += '<div><a title="Web Service" class="tooltips-button-function web-service-ponto-consumo-tooltip" id="cod_' + feature.values_.cod_ponto_cons + '"><i class="fa fa-home"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS_PRD:g_reservatorios":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // hiperligação
                if (feature.values_.hiperligacao)
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                else
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;
            case "GP_DOUROGAS_PRD:gpr_reservatorios":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // hiperligação
                if (feature.values_.hiperligacao)
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function link-reservatorios-tooltip" id="' + feature.values_.hiperligacao + '"><i class="fa fa-sitemap"></i></a></div>';
                else
                    bodyHtml += '<div><a title="Sinóptipo" class="tooltips-button-function"><i class="fa fa-sitemap" style="color: rgb(189 189 189);"></i></a></div>';
                // -- Close div button --
                bodyHtml += '</div>';
                break;

            case "GP_PONTA_DELGADA:EDIFICIOS":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // Add button
                if (myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.PatrimonyTool && myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.AlienateBuilding) {
                    bodyHtml += '<div><a title="Alienar Edifício" data-id="' + feature.id_.split('.')[1] + '" class="tooltips-button-function alienate-building-event" ><i class="fa fa-home"></i></a></div>';
                }
                // -- Close div button --
                bodyHtml += '</div>';
                break;

            case "GP_PONTA_DELGADA:TERRENOS":

                // Add sepatator
                bodyHtml += '<div class="tooltips-separator"></div>'
                // -- Start div for button --
                bodyHtml += '<div class="row tooltips-button">';
                // Add button
                if (myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.PatrimonyTool && myTooltips._mapSgs.getSettings()._mapSettings.operation_visible.AlienateBuilding) {
                    bodyHtml += '<div><a title="Alienar terreno" data-id="' + feature.id_.split('.')[1] + '" class="tooltips-button-function alienate-ground-event" ><i class="fa fa-home"></i></a></div>';
                }
                // -- Close div button --
                bodyHtml += '</div>';
                break;

            default:
            // do nothing
        }

        // Set Element info
        myTooltips._arrayTooltipElement.push({
            id: (feature.getId() == undefined) ? "_" + myTooltips._utility.GetRandomInt(1, 1000) : feature.getId() + "_" + myTooltips._utility.GetRandomInt(1, 1000),
            feature: feature,
            title: tooltipElementNavigation + layerTreeNameTitle,
            content: bodyHtml,
        });

        // Set the 

        // Show the popup
        popupElement.setAttribute('title', titleTooltipElement);
        $(popupElement).attr('data-content', bodyHtml).data('bs.popover').setContent();

        $(popupElement).popover('show');

        // Pan popover if necessary
        myTooltips._PanMapPopover(map, popupElement, titleTooltipElement, bodyHtml, pixel, center, widthMap, heightMap);
    };

    /**
     * 
     * @param {any} idPrumo
     */
    this._GetShowPrumoSignsIconClass = function (idPrumo) {
        const cachePrumo = myTooltips._mapSgs.layerTree._cacheHidePrumoSigns[idPrumo];
        return cachePrumo && cachePrumo.showSigns ? 'fa fa-eye-slash' : 'fa fa-eye';
    }

    /**
     * Utility
     * Pan a popover if outside map limit
     * @param {Map} map, map
     * @param {node} popoverElement, element popover
     * @param {string} title, title of the popover
     * @param {string} bodyHtml, html popover body in string
     * @param {array} mapPixelClick, coordinates in pixel where popover whas ckick
     * @param {array} mapCenter, coordinates of the center of the map
     * @param {int} widthMap, max width map
     * @param {int} heightMap, max height map
     */
    this._PanMapPopover = function (map, popoverElement, title, bodyHtml, mapPixelClick, mapCenter, widthMap, heightMap, closeWait=true) {
        var placement = "";

        // Pan to bottom
        var pixelYPositionPopover = heightMap - mapPixelClick[1];
        var heightPopover = $('#' + document.getElementById(popoverElement.getAttribute('aria-describedby')).id)[0].offsetHeight;
        var maxHeightTop = pixelYPositionPopover + heightPopover;
        if (maxHeightTop > heightMap) {
            placement = 'bottom';
        }

        // Pan to left
        var pixelXPositionPopover = widthMap - mapPixelClick[0];
        var widthPopover = $('#' + document.getElementById(popoverElement.getAttribute('aria-describedby')).id)[0].offsetWidth / 2;
        if (widthPopover > pixelXPositionPopover) {
            placement = 'left';
        }

        // Pan to right
        pixelXPositionPopover = widthMap - mapPixelClick[0];
        widthPopover = $('#' + document.getElementById(popoverElement.getAttribute('aria-describedby')).id)[0].offsetWidth / 2;
        var maxWidthPopover = pixelXPositionPopover + widthPopover;
        if (maxWidthPopover > widthMap) {
            placement = 'right';
        }

        // Build popover
        if (placement !== "") {
            $(popoverElement).popover('destroy');

            $(popoverElement).popover({
                'placement': placement,
                'animation': false,
                'html': true,
                'title': title,
                'content': bodyHtml
            });

            // Event on popover show
            $(popoverElement).on('inserted.bs.popover', function () {
                // Init tooltip object
                myTooltips._InitTooltipOnOpen(closeWait);
            });

            $(popoverElement).popover('show');
        }

        if (placement !== "bottom" && placement !== "top") {
            // Move map up if popover upper bound overcome map superior bound
            maxHeightTop = pixelYPositionPopover + (heightPopover / 2);
            var centerInPx = -1;
            var newCenterInPx = -1;
            var newCenter = -1;
            if (maxHeightTop > heightMap) {
                centerInPx = map.getPixelFromCoordinate(mapCenter);
                newCenterInPx = [centerInPx[0], centerInPx[1] - (maxHeightTop - heightMap)];
                newCenter = map.getCoordinateFromPixel(newCenterInPx);
                map.getView().setCenter(newCenter);
            }

            // Move map down if popover upper bound overcome map inferior bound
            var maxHeightBottom = pixelYPositionPopover - (heightPopover / 2);
            if (maxHeightBottom < 0) {
                centerInPx = map.getPixelFromCoordinate(mapCenter);
                newCenterInPx = [centerInPx[0], centerInPx[1] + Math.abs(maxHeightBottom) + 2];
                newCenter = map.getCoordinateFromPixel(newCenterInPx);
                map.getView().setCenter(newCenter);
            }
        }
    };

    /**
     * Close toolt tip event definition
     */
    this._CloseTooltip = function () {
        $('#close-popover').on('click', function () {
            $(".popover").popover('hide');
            myTooltips._sourceTooltips.clear();

            // Reset feature info
            myTooltips._featureInfo = {
                id: null,
                feature: null,
                idLayer: null,
                mode: 'read',
                fromMap: false
            };
        });
    };

    /**
     * Open entity detail from tooltip definition
     */
    this._OpenEntityDetail = function () {

        // Event open entity information
        $('#tooltips-function-cable-tool-go-to-entity').on('click', function () {
            // Open detail entity
            //myTooltips._gotoEntityDetailCallback(myTooltips._featureInfo);
            var index = $(this).attr("index-element");
            myTooltips._GoToEntityDetail(index);

            // Close tooltip
            $(".popover").popover('hide');
            //myTooltips._sourceTooltips.clear();
        });

        $('#show-hide-signal').off('click').on('click', (e) => {

            const idPrumo = $('#show-hide-signal').attr('data-id-prumo');

            if (idPrumo) {
                if (myTooltips._mapSgs.layerTree._cacheHidePrumoSigns.hasOwnProperty(idPrumo)) {
                    myTooltips._mapSgs.layerTree._cacheHidePrumoSigns[idPrumo].showSigns = !myTooltips._mapSgs.layerTree._cacheHidePrumoSigns[idPrumo].showSigns;
                }

                $('#show-hide-signal').removeClass();
                $('#show-hide-signal').addClass(myTooltips._GetShowPrumoSignsIconClass(idPrumo));

                // myTooltips._mapSgs.map.render();
                let signLayer = null;
                const layers = myTooltips._mapSgs.map.getLayers().getArray();

                layers.some((layer) => {
                    const resultSplit = layer.getProperties().name ? layer.getProperties().name.split(':') : [];

                    if (resultSplit.length > 1 && resultSplit[1] === 'vw_sinalizacao_vertical_direcional_geo') {
                        signLayer = layer;
                        return true;
                    }
                    return false;
                });

                if (signLayer) {
                    signLayer.changed();
                }
            }
        });
    };

    /**
     * Fill entity specific information
     */
    this._FillEntitySpecificInfo = function () {

    };

    /**
     * Save event state event definition
     */
    this._SaveEntity = function () {

    };

    /**
     * Init object on tooltip open
     */
    this._InitTooltipOnOpen = function (closeWait=true) {

        // Close popover
        myTooltips._CloseTooltip();

        // Go to entity detail
        myTooltips._OpenEntityDetail();

        // Fill Entity specific information
        myTooltips._FillEntitySpecificInfo();

        // Save entity
        myTooltips._SaveEntity();

        // Stop wait
        if (closeWait)
            myTooltips._utility.ShowWait('tooltips-spinner', false);

        // for any lighbox image
        lightbox.init();
        setTimeout(function () {
            // Event to show profile
            $('.popover a.lightbox-link').click(function (e) { lightbox.start($(this)); e.preventDefault(); return false; });

            // Event to calculate pipe profile
            $('.tooltips-button-profile').off('click').on('click', function () {

                window['tooltip-profile'] = this.getAttribute('cod-pipe-code');
                window['tooltip-profile-system'] = this.getAttribute('cod-pipe-system');
                app.Select.getFeatures().clear();
                $('#button-profile-analysis').click();

            });

            // Event open google street map
            $('.tooltips-button-google-street').off('click').on('click', function () {
                var longitude = $('.tooltips-button-google-street').attr("longitude");
                var latitude = $('.tooltips-button-google-street').attr("latitude");
                myTooltips._mapStreetView.SetCoordinate([parseFloat(longitude), parseFloat(latitude)])

                myTooltips._mapStreetView.ShowGoogleStreet();
            });

            // Event open simulation
            $('.tooltips-button-simulate').off('click').on('click', function () {
                var options = { type: "ID", feature: feature };
                myTooltips._mapSgs._avimTool.RunSimulation(options);
            });

            // Event to high light pipe group
            $('.tooltips-button-pipe').off('click').on('click', function () {
                // Get pipe group
                var codPipeGroup = this.getAttribute('cod-pipe-group');

                $.ajax({
                    type: 'GET',
                    url: '/rest/app/WaterWaste/GetAllPipeSegmentFromPipeGroup?codPipeGroup=' + codPipeGroup,
                    contentType: "application/json",
                    success: function (data) {
                        if (data.error) {
                            toastr["error"]("Erro na identificação do colector");
                        }
                        else {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    // Get Ids pipe
                                    var arrayIds = [];
                                    for (var i = 0; i < data.result.list_pipe_segment.length; i++) {
                                        var objPipeSegment = data.result.list_pipe_segment[i];
                                        arrayIds.push(objPipeSegment.id);
                                    }
                                    var gpSource = myTooltips._mapSgs.getSettings()._mapSettings.search_toponymy.workspaceSearchToponymy == 'GP_MEALHADA' ? 'GP_MEALHADA' : 'GP';
                                    // HighLight pipe group
                                    myTooltips._mapSgs.SetFeaturesHighlightByArray(gpSource, 'vw_ww_pipe_line_1', true, arrayIds);

                                    toastr["success"]("Colector identificado");
                                    break;
                                case 'ERROR':
                                    toastr["error"]("Erro na identificação do colector");
                                    break;
                                default:
                            }
                        }
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na identificação do colector");
                    }
                });
            });

            // Event in web service
            myTooltips._navisionTool.getAllClientByRamal();

            // Event ien web service
            myTooltips._navisionTool.getAllClientByPredio('web-service-ponto-consumo-tooltip');

            // Search network information
            if (myTooltips._mapSgs._settings.getVisibleOperations().SearchNetwork)
                myTooltips._mapSgs._searchNetworkTool.getLayersByCodObra();

            // Button on tooltip for donwload file
            $('#id-download-file').off('click').on('click', function () {

                $.ajax({
                    type: 'POST',
                    url: '/rest/app/FileManager/DownloadFileNAS?url=' + this.classList.value,
                    dataType: 'json',
                    contentType: "application/json",
                    success: function (data) {


                        $.ajax({
                            type: 'POST',
                            url: '/rest/app/FileManager/DownloadFileHost',
                            dataType: 'json',
                            contentType: "application/json",
                            success: function (data) {


                                var link = document.createElement("a");
                                document.body.appendChild(link);
                                link.setAttribute("type", "hidden");
                                link.href = "data:text/plain;base64," + data.result;
                                link.download = "Download.zip";
                                link.click();
                                document.body.removeChild(link);


                            },
                            error: function (request, status, error) {
                                toastr["error"]("Erro ao descarregar ficheiros");
                            }
                        });


                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro ao descarregar ficheiros da NAS");
                    }
                });

            });

            // Button on tooltip for view information on "reservatórios sonorgas Sinóptipo"
            $('.link-reservatorios-tooltip').off('click').on('click', function () {
                window.open(this.id);
            });

            // Button on tooltip for alienate building (used on ponta delgada)
            $('.alienate-building-event').off('click').on('click', function () {

                var bool = confirm("Tem a certeza?");
                if (bool == true) {

                    $.ajax({
                        type: 'POST',
                        url: '/rest/app/PatrimonyTool/CreateAlienateBuildingById?id=' + this.dataset.id + '&type=Gratuito' + '&userName=' + myTooltips._mapSgs._settings.userInfo.userName,
                        dataType: 'json',
                        contentType: "application/json",
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na criação");
                            }
                            else {

                                var view = myTooltips._mapSgs.map.getView();
                                var zoom = myTooltips._mapSgs.map.getView().getZoom();
                                view.animate({
                                    zoom: zoom - 1,
                                    duration: 1000
                                });

                                toastr["success"]("Edificio Alienado criado com sucesso");

                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na criação");
                        }
                    });

                }

            });

            // Button on tooltip for alienate ground (used on ponta delgada)
            $('.alienate-ground-event').off('click').on('click', function () {

                var bool = confirm("Tem a certeza?");
                if (bool == true) {

                    $.ajax({
                        type: 'POST',
                        url: '/rest/app/PatrimonyTool/CreateAlienateGroudById?id=' + this.dataset.id + '&TPABATE=0' + '&userName=' + myTooltips._mapSgs._settings.userInfo.userName,
                        dataType: 'json',
                        contentType: "application/json",
                        success: function (data) {
                            if (data.error) {
                                toastr["error"]("Erro na criação");
                            }
                            else {

                                var view = myTooltips._mapSgs.map.getView();
                                var zoom = myTooltips._mapSgs.map.getView().getZoom();
                                view.animate({
                                    zoom: zoom - 1,
                                    duration: 1000
                                });

                                toastr["success"]("Edificio Alienado criado com sucesso");

                            }
                        },
                        error: function (request, status, error) {
                            toastr["error"]("Erro na criação");
                        }
                    });

                }

            });

            // Event to high light pipe group
            $('.tooltips-button-open-consult-entity').off('click').on('click', function () {
                var idFeature = $(this).attr("data-id");
                // Get feature of the tooltip
                var featureInfo = myTooltips._arrayTooltipFeature.find(c => c.featureId == idFeature);
                if (featureInfo) {

                    var processo = $(this).attr("processo");
                    var processYear = $(this).attr("processYear");
                    var ObjProcess = featureInfo.feature.getProperties();
                    $('#id-modal-pdm-analyze-entity-result-process')[0].innerHTML = processo;

                    // Close tooltip
                    myTooltips._CloseTooltip();

                    // Clean Entity
                    $('#id-modal-pdm-analyze-entity-result-layer ul').empty();

                    $('#id-modal-pdm-analyze-entity-result-process span.id-process')[0].innerHTML = ObjProcess.PROCESSO.split("/")[0];
                    $('#id-modal-pdm-analyze-entity-result-process span.type')[0].innerHTML = ObjProcess.TIPO;
                    $('#id-modal-pdm-analyze-entity-result-process span.date')[0].innerHTML = myTooltips._utility.TransformDateServerInDateII(ObjProcess.DATA);
                    $('#id-modal-pdm-analyze-entity-result-process span.year')[0].innerHTML = processYear;
                    $('#id-modal-pdm-analyze-entity-result-process span.area')[0].innerHTML = ObjProcess.AREA + " m" + "<sup>2</sup>";

                    app.sgs.Map._territorialManagement.ExecutePdmAnalyzeEntity(featureInfo.feature);
                }
            });

            // Event to get the previous element on tooltip
            $('.tooltip-previous-element').off('click').on('click', function () {
                var indexElement = parseInt($(this).attr("index-element"));
                var totalElement = parseInt($(this).attr("total-feature"));

                if (indexElement == 0) {
                    indexElement = totalElement - 1;
                }
                else {
                    indexElement = indexElement - 1;
                }

                myTooltips._ShowTooltipForFeature(indexElement);
            });

            // Event to ger the next element on tooltip
            $('.tooltip-next-element').off('click').on('click', function () {
                var indexElement = parseInt($(this).attr("index-element"));
                var totalElement = parseInt($(this).attr("total-feature"));

                if (indexElement == (totalElement-1)) {
                    indexElement = 0;
                }
                else {
                    indexElement = indexElement + 1;
                }

                myTooltips._ShowTooltipForFeature(indexElement);
            });

        }, 500)
    };

    // -- end private method ----------------------------------------------------------------------
};

/**
 * Init tooltips information
 * @param {ol.map} map, ol map
 * @param {hash} hashLayerInfo, hash with all the layer
 */
Tooltips.prototype.InitTooltips = function (MapSgs, hashLayerInfo) {
    // Fill object's whit layer with tooltips capbility
    this._FillLayerTooltips(hashLayerInfo);

    // Create overlay tooltip
    this._CreateOverlayTooltips($('#' + this._tooltipNodeId)[0], null, null);

    // Add overlay tooltip to map
    MapSgs.map.addOverlay(this._overlayTooltips);

    // Keep map sgs
    this._mapSgs = MapSgs;

    // Map street view object
    if (this._mapSgs.getSettings().getVisibleOperations().StreetMapView) {
        this._mapStreetView = new MapStreetView();
        this._mapStreetView.Init(this._mapSgs);
    }

    // Init navisionTool
    this._navisionTool = new NavisionTool();
    this._navisionTool.Init(this._mapSgs);
};
